import {
  Component,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnDestroy {
  destroy$ = new Subject();

  constructor(config: NgbModalConfig) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }
}
